import SignInLoginComponent from "../components/signIn/SignInLoginComponent";

const SignInPage = () => {
	return <SignInLoginComponent />;
};

export default SignInPage;
